module.exports = __webpack_public_path__ + "static/media/Contact.740a5b3c.jpg";